import React from 'react';
import { Question as QuestionComponent } from './Question';

export const ProgressBar = ({ total, completed }) => {
    const percentage = total === 0 ? 0 : Math.round((completed / total) * 100);

    return (
        <div style={{
            position: 'sticky',
            top: 0,
            zIndex: 1000,
            background: 'white',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            marginBottom: '20px'
        }}>
            <div style={{
                maxWidth: '1200px',
                margin: '0 auto',
                padding: '10px 20px',
                display: 'flex',
                alignItems: 'center',
                gap: '15px'
            }}>
                <span style={{ fontWeight: 'bold', fontSize: '14px', whiteSpace: 'nowrap' }}>
                    Overall Progress: {percentage}%
                </span>
                <div style={{
                    flex: 1,
                    height: '10px',
                    backgroundColor: '#e0e0e0',
                    borderRadius: '5px',
                    overflow: 'hidden'
                }}>
                    <div style={{
                        width: `${percentage}%`,
                        height: '100%',
                        backgroundColor: '#4caf50',
                        transition: 'width 0.3s ease-in-out'
                    }} />
                </div>
            </div>
        </div>
    );
};

export const Section = ({ title, questions, answers, onAnswerChange }) => {
    return (
        <div className="section-container" style={{ marginBottom: '2rem', border: '1px solid #ccc', padding: '1rem', borderRadius: '4px' }}>
            <h2 style={{ marginTop: 0, borderBottom: '2px solid #333', paddingBottom: '0.5rem' }}>{title}</h2>
            {questions.map((q) => (
                <QuestionComponent
                    key={q.id}
                    question={q}
                    answer={answers[q.id]}
                    onChange={(val) => onAnswerChange(q.id, val)}
                />
            ))}
        </div>
    );
};

export const Sidebar = ({ sections, completedSections, activeSection }) => {
    const handleScrollToSection = (section) => {
        const element = document.getElementById(section);
        if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <aside style={{
            width: '250px',
            flexShrink: 0,
            position: 'sticky',
            top: '80px', // Below progress bar
            zIndex: 50,
            alignSelf: 'flex-start',
            padding: '10px',
            background: '#f9f9f9',
            borderRadius: '8px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            maxHeight: 'calc(100vh - 100px)',
            overflowY: 'auto'
        }}>
            <h3 style={{ marginTop: 0, marginBottom: '15px', fontSize: '1.1rem', borderBottom: '1px solid #eee', paddingBottom: '10px' }}>Sections</h3>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                {sections.map(section => (
                    <li key={section} style={{ marginBottom: '8px' }}>
                        <button
                            onClick={() => handleScrollToSection(section)}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                width: '100%',
                                padding: '8px 12px',
                                background: 'none',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                textAlign: 'left',
                                fontSize: '0.9rem',
                                color: activeSection === section ? '#2196f3' : '#333',
                                fontWeight: activeSection === section ? 'bold' : 'normal',
                                backgroundColor: activeSection === section ? 'rgba(33, 150, 243, 0.1)' : 'transparent',
                                transition: 'background-color 0.2s'
                            }}
                        >
                            <span style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                width: '20px',
                                height: '20px',
                                marginRight: '10px',
                                color: completedSections[section] ? '#4caf50' : '#ccc'
                            }}>
                                {completedSections[section] ? '✔' : '○'}
                            </span>
                            <span style={{ flex: 1 }}>{section}</span>
                        </button>
                    </li>
                ))}
            </ul>
        </aside>
    );
};
